<template>
    <div class="common-body-view">
        <div  class="common-title">
            <div @click="back" style="width: 30px;height: 30px;display: flex;align-items: center;justify-content: center;">
                <img src='../img/left.png' style="width: 14px; height: 14px;">
            </div>

            <span class="common-title-text">连点器方案配置</span>
        </div>

        <div class="main">
            <div style="height: 30px;font-size: 14px; display: flex;align-items: flex-end;color: #666666;padding: 0 25px;">
                <div  @click="pageActive = 1" style="flex: 1;height: 30px;position: relative; cursor: pointer;display: flex;align-items: center">
                    <span :style="pageActive === 1 && 'color: #0f78e8'" style="flex: 1">触点</span>
                    <div style="width: 25px;height: 3px;position: absolute;bottom: 0;right: 0;left: 0;margin: auto;" :style="pageActive === 1 && 'background-color: #0f78e8;'"></div>
                </div>

                <div  @click="pageActive = 2" style="flex: 1;height: 30px;position: relative; cursor: pointer;display: flex;align-items: center;margin-left: 15px;">
                    <span :style="pageActive === 2 && 'color: #0f78e8'" style="flex: 1">方案</span>
                    <div style="width: 25px;height: 3px;position: absolute;bottom: 0;right: 0;left: 0;margin: auto;" :style="pageActive === 2 && 'background-color: #0f78e8;'"></div>
                </div>
            </div>

            <div class="main-body">
                <div v-if="pageActive === 1" style="font-size: 14px;">
                    <div style="display: flex;margin-top: 10px;">
                        <div style="width: 50px;">序号</div>
                        <div style="flex: 1;text-align: center;">点击间隔</div>
                        <div style="width: 80px;text-align: center;">删除</div>
                    </div>

                    <div v-for="(item,index) in updatePointList" style="display: flex;align-items: center;margin-top: 8px;">
                        <div style="width: 50px;padding-left: 5px;box-sizing: border-box;font-size: 16px;color: #333333;">
                            {{index + 1}}
                        </div>
                        <div style="flex: 1;display: flex;justify-content: center;">
                            <van-field label-width="0" maxlength="6" type="digit" placeholder="1000" style="width: 110px;border: 0.5px solid #e0e0e0;" class="common-input"
                                       v-model="item.timeInterval" >
                                <template v-slot:right-icon>
                                    毫秒
                                </template>
                            </van-field>
                        </div>

                        <div style="width: 80px;text-align: center;">
                            <img @click="deletePoint(index)" src="../img/delete.png" style="width: 23px;height: 23px;cursor: pointer;">
                        </div>

                    </div>
                </div>

                <div v-if="pageActive === 2">
                    <div class="input-view">
                        <van-field label="方案名" label-width="70" maxlength="20" placeholder="请输入方案名" class="common-input" v-model="name" />
                    </div>

                    <div style="margin-top: 8px;display: flex;font-size: 14px;color: #646566;height: 38px;padding: 0 10px;box-sizing: border-box;align-items: center;">
                        <span>方案循环次数</span>
                        <div style="display: flex;background-color: #eeeeee;padding: 5px 10px;border-radius: 4px;margin-left: 15px;font-size: 12px;">
                            <div @click="infiniteLoop = 1" :class="infiniteLoop === 1 && 'selected-item'" style="padding: 3px 8px;cursor: pointer;">无限</div>
                            <div @click="infiniteLoop = 2" :class="infiniteLoop === 2 && 'selected-item'" style="padding: 3px 8px;cursor: pointer;">有限</div>
                        </div>
                    </div>

                    <div v-if="infiniteLoop === 2" class="input-view" style="">
                        <van-field label="循环次数" label-width="70" type="digit" max="999" maxlength="3" placeholder="请输入循环次数" class="common-input" v-model="loopNum" >
                            <template v-slot:right-icon>
                                次
                            </template>
                        </van-field>
                    </div>

                    <div class="input-view" style="margin-top: 8px;">
                        <van-field label="循环间隔" label-width="70" type="digit" maxlength="6" placeholder="请输入循环间隔" class="common-input" v-model="loopInterval" >
                            <template v-slot:right-icon>
                                毫秒
                            </template>
                        </van-field>
                    </div>

                </div>
            </div>


            <div style="width: 100%; display: flex;justify-content: space-between;height: 30px;padding: 0 15px;box-sizing: border-box;">
                <van-button  @click="exitPlan" type="info" :loading="showLoading" style="height: 30px;width: 110px;font-size: 13px;" color="#aaaaaa">
                    退出方案
                </van-button>

                <van-button  @click="save" type="info" :loading="showLoading" style="height: 30px;width: 110px;font-size: 13px;" color="#0f78e8">
                    保存方案
                </van-button>
            </div>

        </div>
    </div>
</template>

<script>
    import { Toast, Dialog } from 'vant';

    export default {
        name: "auto-click-setting",
        components: {
        },
        data() {
            return {
                showLoading: false,
                pageActive: 2,
                name: '',
                infiniteLoop: 1,
                loopNum: '1',
                loopInterval: '0',
                updatePointList: [],
                parent: this.$parent.$parent,
                planList: [],
                createOrUpdatePlan: 0,
            }
        },
        mounted () {
            this.planList = JSON.parse(localStorage.getItem('autoClickPlanList')) || [];
            if (this.parent.createOrUpdatePlan === 1) {//新增
                let plan = this.parent.autoClickPlan;
                this.name = plan.name ? plan.name : '我的连点方案' + (this.planList.length + 1);
                this.infiniteLoop = plan.infiniteLoop;
                this.loopNum = plan.loopNum;
                this.loopInterval = plan.loopInterval;
            }
            else {
                let plan = this.planList[this.parent.selectAutoClickPlanIndex];
                this.name = plan.name;
                this.infiniteLoop = plan.infiniteLoop;
                this.loopNum = plan.loopNum;
                this.loopInterval = plan.loopInterval;
            }

            this.updatePointList = this.parent.autoClickPointList;
        },
        methods: {
            back(){
                this.parent.autoClickPlan = {
                    name: this.name,
                    infiniteLoop: this.infiniteLoop,
                    loopNum: this.loopNum,
                    loopInterval: this.loopInterval,
                }
                this.parent.autoClickSettingShow = false;
            },
            exitPlan() {
                //let msg = this.parent.createOrUpdatePlan === 1 ? '方案还未保存，确认要退出吗?' : '确认要退出方案吗';
                let msg = '确认要退出方案吗';
                Dialog.confirm({
                    message: msg,
                }).then(() => {
                    this.parent.exitAutoClickPlan();
                }).catch(() => {
                });
            },
            save() {
                if (!this.name) {
                    Toast('请输入方案名');
                    return ;
                }
                if (this.infiniteLoop === 2) {
                    if (!this.loopNum) {
                        Toast('请输入循环次数');
                        return ;
                    }
                    if (this.loopNum <= 0) {
                        Toast('请输入正确的循环次数');
                        return ;
                    }
                }
                if (this.parent.autoClickPointList.length === 0) {
                    Toast('请添加至少一个触点');
                    return ;
                }
                if (!this.loopInterval) {
                    Toast('请输入循环间隔');
                    return ;
                }

                let clickPlan = {
                    pointList: this.parent.autoClickPointList,
                    name: this.name,
                    infiniteLoop: this.infiniteLoop,
                    loopNum: this.loopNum,
                    loopInterval: this.loopInterval,
                }

                if (this.parent.createOrUpdatePlan === 1) {//新增
                    if (this.planList.length >= 10) {
                        Toast('最多保存10个方案');
                        return ;
                    }

                    this.planList.push(clickPlan);
                }
                else {//修改方案
                    this.planList[this.parent.selectAutoClickPlanIndex] = clickPlan;
                }

                localStorage.setItem('autoClickPlanList', JSON.stringify(this.planList));
                Toast('方案保存成功');

                this.back();
            },
            deletePoint(index) {
                Dialog.confirm({
                    message: '确认删除 ' + (index + 1) + ' 号触点吗?',
                }).then(() => {
                    this.parent.autoClickPointList.splice(index, 1);
                }).catch(() => {
                });
            },
        }
    }
</script>

<style scoped>
    .selected-item {
        background-color: #0f78e8;
        border-radius: 4px;
        color: #FFFFFF;
    }

    .common-body-view {
        background-color: #f0f0f0;
        border-radius: 10px;
        width: 100%;
        height: 320px;
        box-sizing: border-box;
        max-width: 400px;
        position: relative;
        margin: 0 auto;
    }

    .common-title {
        height: 50px;
        display: flex;
        align-items: center;
        padding-right: 20px;
        padding-left: 5px;
    }

    .common-title-text {
        font-size: 14px;
        color: #444444;
        font-weight: bold;
        margin-left: 5px;
    }

    .main{
        width: 95%;
        height: 260px;
        background-color: #ffffff;
        border-radius: 5px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 5px 5px;
        box-sizing: border-box;
        position: relative;
    }
    .main-body {
        width: 100%;
        padding: 0 15px 15px;
        box-sizing: border-box;
        height: 200px;
        overflow-y: auto;
        text-align: left;
    }

    .main-body {
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .main-body::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }

    .input-view{
        width: 100%;
        height: 38px;
        border-radius: 5px;
        display: flex;
        margin-top: 8px;
        border: 0.5px solid #e0e0e0;
        //box-shadow: 2px 2px 10px 3px rgba(0,0,0,.1);
    }
    .common-input {
        font-size: 14px;
        height: 38px;
        border-radius: 5px;
    }

    .van-cell {
        padding: 7px 10px;
    }
    /deep/ .van-field__control {
        color: #333333;
    }
    .van-cell::after {
        border-bottom: none;
    }

</style>